












































import { Component, Prop, Vue } from 'vue-property-decorator';
import InformationRow from '@/components/display/information-row.vue';
import moment from 'moment';
import { TrialService } from '@/services/trial-service';
import { Product, ProductStatus } from '@/api';
import TooltipButton from '@/components/elements/buttons/tooltip-button.vue';
import { getGeneralActionText } from '@/common/HelpTextUtils';

@Component({
	computed: {
		ProductStatus() {
			return ProductStatus;
		},
	},
	methods: {
		getGeneralActionText,
	},
	components: { InformationRow, TooltipButton },
})
export default class TrialRow extends Vue {
	@Prop({ required: true })
	public billingAttributes!: any | null;

	@Prop({ required: true })
	public product!: Product;

	private trialService = new TrialService();

	private get tense(): string {
		return moment.utc(this.billingAttributes.trialStatus.trialEnds.value).diff(moment.now()) > 0
			? 'Ends'
			: 'Ended';
	}
}
